"use strict";

document.addEventListener('DOMContentLoaded', function () {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	window.addEventListener('resize', () => {
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});

	/**
	 * Header fixed + spacer (prevents layout jump)
	 */
	const header = document.querySelector('.header');
	const threshold = 40;
	let timer;

	if (header) {
		// Spacer to keep layout stable when header becomes fixed
		let spacer = header.nextElementSibling;
		if (!spacer || !spacer.classList || !spacer.classList.contains('header-spacer')) {
			spacer = document.createElement('div');
			spacer.className = 'header-spacer';
			spacer.style.height = '0px';
			header.insertAdjacentElement('afterend', spacer);
		}

		const getHeaderHeight = () => header.getBoundingClientRect().height;

		const setFixed = () => {
			if (header.classList.contains('fixed')) return;

			// Lock current (non-fixed) header height as spacer height
			const h = getHeaderHeight();
			spacer.style.height = `${h}px`;

			header.classList.add('fixed');
		};

		const unsetFixed = () => {
			if (!header.classList.contains('fixed')) return;

			header.classList.remove('fixed');
			spacer.style.height = '0px';
		};

		// Initial state (if page is opened already scrolled)
		const initialTrigger = getHeaderHeight() + threshold;
		if (window.scrollY > initialTrigger) setFixed();

		window.addEventListener("scroll", () => {
			clearTimeout(timer);

			// If spacer already set, use it as the baseline height
			const baseHeight =
				spacer.style.height && spacer.style.height !== '0px'
					? parseFloat(spacer.style.height)
					: getHeaderHeight();

			if (window.scrollY > baseHeight + threshold) {
				timer = setTimeout(setFixed, 50);
			} else if (window.scrollY < baseHeight - threshold) {
				timer = setTimeout(unsetFixed, 50);
			}
		});

		// If only height changes (not width), keep spacer in sync when fixed
		window.addEventListener('resize', () => {
			if (!header.classList.contains('fixed')) return;

			// Measure "normal" header height: temporarily remove fixed
			header.classList.remove('fixed');
			spacer.style.height = `${getHeaderHeight()}px`;
			header.classList.add('fixed');
		});
	}

	// menu toggle
	const menuToggle = document.querySelector('.js-menu-toggle');

	if (menuToggle) {
		const menu = menuToggle.nextElementSibling;

		menuToggle.addEventListener('click', () => {
			menu.classList.toggle('menu--open');
			document.body.classList.toggle('scroll-lock');
		});

		if (menu) {
			document.addEventListener('click', (event) => {
				if (!menu.contains(event.target) && !menuToggle.contains(event.target)) {
					menu.classList.remove('menu--open');
					document.body.classList.remove('scroll-lock');
				}
			});
		}
	}

	// auto reload after resize for fix problem related to use wpmd_is_device
	let windowWidth = window.innerWidth;

	window.addEventListener('resize', function () {
		if (window.innerWidth != windowWidth) {
			window.location.reload();
		}
	}, true);

	const popup = document.getElementById('callback-popup');
	if (!popup) return;

	const form = document.getElementById('callback-form');
	if (!form) return;

	const successText = popup.querySelector('.callback-success-text');
	const errorText = popup.querySelector('.callback-error-text');

	const resetMessage = () => {
		if (successText) successText.style.display = 'none';
		if (errorText) {
			errorText.style.display = 'none';
			errorText.textContent = '';
		}
	};

	const openPopup = () => {
		resetMessage();
		popup.classList.add('open');
		popup.setAttribute('aria-hidden', 'false');
	};

	const closePopup = () => {
		resetMessage();
		popup.classList.remove('open');
		popup.setAttribute('aria-hidden', 'true');
	};

	// Open / Close
	document.addEventListener('click', (e) => {
		const openBtn = e.target.closest('[data-callback-btn]');
		if (openBtn) {
			e.preventDefault();
			openPopup();
			return;
		}

		const closeBtn = e.target.closest('[data-callback-close]');
		if (closeBtn) {
			e.preventDefault();
			closePopup();
		}
	});

	// ESC closes popup
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && popup.classList.contains('open')) {
			closePopup();
		}
	});

	// Submit
	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		resetMessage();

		const formData = new FormData(form);
		formData.append('action', 'send_callback_request');

		const send = async (token = '') => {
			if (token) formData.set('token', token);

			try {
				const res = await fetch(callbackPopupData.ajaxUrl, {
					method: 'POST',
					body: formData,
				});

				const result = await res.json();

				if (result.success) {
					if (successText) successText.style.display = 'block';
					form.reset();
					setTimeout(closePopup, 2000);
				} else {
					if (errorText) {
						errorText.textContent = result.data || 'Помилка відправлення';
						errorText.style.display = 'block';
					}
				}
			} catch {
				if (errorText) {
					errorText.textContent = 'Помилка зʼєднання';
					errorText.style.display = 'block';
				}
			}
		};

		// Optional reCAPTCHA v3
		if (window.callbackPopupData && callbackPopupData.useRecaptcha && callbackPopupData.recaptchaSiteKey && window.grecaptcha) {
			grecaptcha.ready(() => {
				grecaptcha
				.execute(callbackPopupData.recaptchaSiteKey, { action: 'submit' })
				.then((token) => send(token))
				.catch(() => send(''));
			});
		} else {
			send('');
		}
	});
});
